import React from 'react'
import { Box } from '@chakra-ui/react'
import SeatingPlanTable from './components/SeatingPlanTable'

export default function SeatingPlansView() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SeatingPlanTable />
    </Box>
  )
}
